import React from "react";
import './mapa.css';

const Mapa = () => {
    return (
        <div className="container-fluid map-container">
            <div className="row">
                <div className="col-12">
                    <iframe
                        title="Ubicación Quality Seal en Google Maps"   // <-- agrega esto
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3766.557237996893!2d-99.12234622406082!3d19.25811884622852!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x85ce01463b27f797%3A0xbb302c385faca0b5!2sQUALITY%20SEAL%2C%20SELLOS%20DE%20SEGURIDAD!5e0!3m2!1ses-419!2smx!4v1741127998252!5m2!1ses-419!2smx"
                        width="100%"
                        height="350"
                        style={{ border: "0" }}
                        allowFullScreen={true}
                        loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade"
                    />

                </div>
            </div>
        </div>
    );
};

export default Mapa;
